import { NoddiTooltip } from 'noddi-ui-web';
import {
  parseTireDimension,
  splitTireDimensionText,
  tireDimensionBreakdownItems,
  TireDimensionParts
} from 'noddi-util';

type Props = {
  value?: string | null;
  className?: string;
};

export const TireDimensionLabel = ({ value, className }: Props) => {
  if (!value) {
    return null;
  }

  return (
    <span className={className}>
      {splitTireDimensionText(value).map((part, index) => {
        const parts = part.type === 'dimension' ? parseTireDimension(part.value) : null;
        return parts ? (
          <DimensionHover key={`${part.value}-${index}`} label={part.value} parts={parts} />
        ) : (
          <span key={`${part.value}-${index}`}>{part.value}</span>
        );
      })}
    </span>
  );
};

const DimensionHover = ({ label, parts }: { label: string; parts: TireDimensionParts }) => {
  return (
    <NoddiTooltip
      label={`What ${label} means`}
      stopEventPropagation={false}
      tooltipContentWrapperClassName='max-w-xs text-left'
      trigger={<span className='cursor-help underline decoration-dotted underline-offset-2'>{label}</span>}
      content={
        <div className='flex flex-col gap-2'>
          <p className='font-medium'>{label}</p>
          <ul className='list-disc pl-4'>
            {tireDimensionBreakdownItems(parts).map((item) => (
              <li key={item.meaning}>
                {item.meaning}: <span className='font-semibold'>{item.value}</span>
                {item.extra}
              </li>
            ))}
          </ul>
        </div>
      }
    />
  );
};
